import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
import Layout from '@/views/layout/Layout'
export const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { type: 'login' },
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/login/register',
    name: 'login',
    meta: { type: 'login', isRegister: true },
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '',
    component: Layout,
    name: 'Index',
    children: [
      {
        path: '/',
        name: 'home',
        meta: { title: '首页', icon: 'home', affix: true, type: 'home' },
        component: () => import('../views/index/index.vue'),
      },
      {
        path: '/accountInfo',
        name: 'accountInfo',
        meta: { title: '帐户信息', type: 'account_info' },
        component: () => import('../views/accountInfo/accountInfo.vue'),
      },
      {
        path: '/changepassword',
        name: 'changepassword',
        meta: { title: '修改密码', type: 'change_password' },
        component: () => import('../views/changepassword/changepassword.vue'),
      },
      // {
      //   path: '/bindphone',
      //   name: 'bindphone',
      //   meta: { title: '手机绑定' , type: 'bind_phone'},
      //   component: () => import('../views/bindphone/bindphone.vue'),
      // },
      // {
      //   path: '/loginRecord',
      //   name: 'loginRecord',
      //   meta: { title: '登录记录', type: 'login_record' },
      //   component: () => import('../views/loginRecord/loginRecord.vue'),
      // },
      {
        path: '/memberinfo',
        name: 'memberinfo',
        meta: {
          title: '会员个人信息',
          permissions: ['member'],
          type: 'member_info',
        },
        component: () => import('../views/memberinfo/memberinfo.vue'),
      },
      {
        path: '/referrerinfo',
        name: 'referrerinfo',
        meta: {
          title: '推荐人信息',
          permissions: ['member'],
          type: 'referrer_info',
        },
        component: () => import('../views/referrerinfo/referrerinfo.vue'),
      },
      {
        path: '/tree',
        name: 'tree',
        meta: { title: '团队结构', permissions: ['member'], type: 'team_tree' },
        component: () => import('../views/tree/tree.vue'),
      },
      {
        path: '/LTP10',
        name: 'LTP10',
        meta: {
          title: '家族团队10代业绩',
          permissions: ['member'],
          type: '10LevelTeamPerformance',
        },
        component: () => import('../views/LTP10/LTP10.vue'),
      },
      {
        path: '/lowermemberdata',
        name: 'lowermemberdata',
        meta: {
          title: '下级会员数据',
          permissions: ['member'],
          type: 'lower_member_data',
        },
        component: () => import('../views/lowermemberdata/lowermemberdata.vue'),
      },
      {
        path: '/memberstatus',
        name: 'memberstatus',
        meta: {
          title: '会员VIP状态',
          permissions: ['member'],
          type: 'member_status',
        },
        component: () => import('../views/memberstatus/memberstatus.vue'),
      },
      {
        path: '/incomedetails',
        name: 'incomedetails',
        meta: { title: '收益明细', type: 'income_details' },
        component: () => import('../views/incomedetails/incomedetails.vue'),
      },
      {
        path: '/ewallet',
        name: 'ewallet',
        meta: { title: '电子钱包', type: 'e_wallet' },
        component: () => import('../views/ewallet/ewallet.vue'),
      },
      {
        path: '/purchasemeal',
        name: 'purchasemeal',
        meta: { title: '选择套餐', type: 'purchase_meal' },
        component: () => import('../views/purchasemeal/purchasemeal.vue'),
      },
      {
        path: '/memberexplain',
        name: 'memberexplain',
        meta: { title: '会员权益说明', type: 'member_explain' },
        component: () => import('../views/memberexplain/memberexplain.vue'),
      },
      {
        path: '/purchasehistory',
        name: 'purchasehistory',
        meta: { title: '购买记录', type: 'purchase_history' },
        component: () => import('../views/purchasehistory/purchasehistory.vue'),
      },
      {
        path: '/order',
        name: 'order',
        meta: { title: '订单管理', type: 'order' },
        component: () => import('../views/order/order.vue'),
      },
      {
        path: '/orderinfo',
        name: 'order',
        meta: { title: '订单详情', type: 'order_info' },
        component: () => import('../views/orderinfo/orderinfo.vue'),
      },
      {
        path: '/notify',
        name: 'notify',
        meta: { title: '消息通知', type: 'notify' },
        component: () => import('../views/notify/notify.vue'),
      },
      {
        path: '/notifyinfo',
        name: 'notify',
        meta: { title: '消息通知详情', type: 'notify_info' },
        component: () => import('../views/notifyinfo/notifyinfo.vue'),
      },
      {
        path: '/points_RP',
        name: 'points_RP',
        meta: { title: '积分明细', type: 'rp_point_detail' },
        component: () => import('../views/points/points.vue'),
      },
      {
        path: '/points_HP',
        name: 'points_HP',
        meta: { title: '积分明细', type: 'hp_point_detail' },
        component: () => import('../views/points/points.vue'),
      },
      {
        path: '/memberpointsdetail',
        name: 'memberpointsdetail',
        meta: { title: '会员点数明细', type: 'member_points_detail' },
        component: () =>
          import('../views/memberpointsdetail/memberpointsdetail.vue'),
      },
      {
        path: '/productintroduce',
        name: 'productintroduce',
        meta: { title: '产品介绍', type: 'product_introduce' },
        component: () =>
          import('../views/productintroduce/productintroduce.vue'),
      },
      {
        path: '/redeem',
        name: 'points_RP',
        meta: { title: '优惠码', type: 'redeem' },
        component: () => import('../views/redeem/redeem.vue'),
      },
      {
        path: '/redeem_HP',
        name: 'redeem_HP',
        meta: { title: 'HP兑换优惠码', type: 'redeem_hp' },
        component: () => import('../views/redeem_HP/redeem_HP.vue'),
      },
      {
        path: '/exchangecode',
        name: 'exchangecode',
        meta: { title: '我的优惠码', type: 'exchange_code' },
        component: () => import('../views/exchangecode/exchangecode.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch((err) => err)
}
export default router
